/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { instanceOfFxIdApplicationPublicDataBuilderPlatformDataOptionsWindowsOptions, FxIdApplicationPublicDataBuilderPlatformDataOptionsWindowsOptionsFromJSONTyped, FxIdApplicationPublicDataBuilderPlatformDataOptionsWindowsOptionsToJSON, } from './FxIdApplicationPublicDataBuilderPlatformDataOptionsWindowsOptions';
export function FxIdApplicationPublicDataBuilderPlatformDataOptionsWindowsFromJSON(json) {
    return FxIdApplicationPublicDataBuilderPlatformDataOptionsWindowsFromJSONTyped(json, false);
}
export function FxIdApplicationPublicDataBuilderPlatformDataOptionsWindowsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdApplicationPublicDataBuilderPlatformDataOptionsWindowsOptions(json)) {
        return FxIdApplicationPublicDataBuilderPlatformDataOptionsWindowsOptionsFromJSONTyped(json, true);
    }
    return {};
}
export function FxIdApplicationPublicDataBuilderPlatformDataOptionsWindowsToJSON(json) {
    return FxIdApplicationPublicDataBuilderPlatformDataOptionsWindowsToJSONTyped(json, false);
}
export function FxIdApplicationPublicDataBuilderPlatformDataOptionsWindowsToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    if (instanceOfFxIdApplicationPublicDataBuilderPlatformDataOptionsWindowsOptions(value)) {
        return FxIdApplicationPublicDataBuilderPlatformDataOptionsWindowsOptionsToJSON(value);
    }
    return {};
}
//# sourceMappingURL=FxIdApplicationPublicDataBuilderPlatformDataOptionsWindows.js.map